export default __webpack_public_path__ + "static/media/NIAS0590.34I-40838_-24140_0.1b1b7bb4.jpg";